module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "article-list"
  }, [(_vm.heroPost) ? _vm._c('div', {
    staticClass: "hero-post"
  }, [_vm._c('div', {
    staticClass: "wrap-black banner-with-copy"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [(_vm.heroImg) ? _vm._c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "pic",
    style: ('background-image:url(' + _vm.heroImg + ');')
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'blog-article',
        params: {
          id: _vm.heroPost.id
        }
      }
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "overlay"
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 banner-content-wrap",
    class: _vm.heroImg ? 'col-sm-6' : ''
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._c('h1', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'blog-article',
        params: {
          id: _vm.heroPost.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.heroPost.title))])], 1), _vm._v(" "), _vm._c('p', [_vm._v("\n              " + _vm._s(_vm.heroContent) + "\n            ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
    attrs: {
      "to": {
        name: 'blog-article',
        params: {
          id: _vm.heroPost.id
        }
      }
    }
  }, [_vm._v("\n              Read More")])], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "container-fluid sub-articles"
  }, [_vm._c('div', {
    staticClass: "row"
  }, _vm._l((_vm.showList), function(article) {
    return _vm._c('BlogListArticle', {
      attrs: {
        "article": article
      }
    })
  }))]), _vm._v(" "), (_vm.showList.length < _vm.blogPosts.length) ? _vm._c('div', {
    staticClass: "text-center"
  }, [_vm._c('button', {
    staticClass: "btn-pub btn-pub-blank",
    on: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("Load More Articles")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5919982a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/blog/BlogList.vue
// module id = 668
// module chunks = 1